import { useAppSelector } from 'src/store';
export const useUser = () => {
  const user = useAppSelector(state => state.user.user?.preferred_username);
  const resourceAccess = useAppSelector(state => state.user.user?.resourceAccess);
  const roles =
    resourceAccess && resourceAccess['etmf-ui'] && resourceAccess['etmf-ui'].roles
      ? resourceAccess['etmf-ui'].roles
      : [];
  const preferences = useAppSelector(state => state.user.user?.preferences);
  const userName = useAppSelector(state => state.user.user?.firstName + ' ' + state.user.user?.lastName);
  return { user, roles, preferences, userName };
};
